import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from '../../utils/Config';

interface UserState {
    userDetails: UserDetails;
}

const initialState: UserState = {
    userDetails: {
        name: '',
        department: '',
        image: '',
        mobileNumber: '',
        emailAddress: '',
        roleBriefs: []
    },
};

const userDetailsSlice = createSlice({
    name: 'userDetailsSlice',
    initialState,
    reducers: {
        setUserDetails(state, action: PayloadAction<UserDetails>) {
            state.userDetails = action.payload;
        }
    }
});

export const { setUserDetails } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
